<template>
  <article class="gs-funnel-list-card" :class="{ 'is-unpublished': funnel.is_live != 1 }">
    <button
      type="button"
      class="gs-funnel-list-card__media"
      :aria-label="`Open ${funnel.name} dashboard`"
      @click="sendToDashboard"
    >
      <img
        v-if="funnelImage"
        class="gs-funnel-list-card__image"
        :src="funnelImage"
        :alt="funnel.name"
      />
      <gifts-icon v-else class="gs-funnel-list-card__placeholder" />
    </button>
    <div class="gs-funnel-list-card__content">
      <div class="gs-funnel-list-card__main">
        <div class="gs-funnel-list-card__title-row">
          <h3>{{ funnel.name }}</h3>
          <span
            class="gs-funnel-list-card__status"
            :class="funnel.is_live == 1 ? 'is-live' : 'is-draft'"
          >
            {{ funnel.is_live == 1 ? 'Live' : 'Not live' }}
          </span>
        </div>
        <p class="gs-funnel-list-card__meta">
          <span>{{ funnel.internal_name || 'No internal name' }}</span>
          <span>{{ funnel.all_products ? funnel.all_products.length : 0 }} {{ $t('frontend_products') }}</span>
          <span>{{ $t('frontend_groovevideo_videos_index_updated') }} {{ funnel.last_updated_on }}</span>
        </p>
        <funnel-draft-notice v-if="funnel.is_live != 1" @publish="$emit('onPublishFunnel', funnel.id)" />
      <p class="gs-funnel-list-card__description">{{ funnel.description || 'No description added.' }}</p>
      </div>
      <div class="gs-funnel-list-card__actions">
        <div class="gs-funnel-list-card__icons">
          <button
            v-for="option in menuItemsIcons"
            :key="option.text"
            type="button"
            class="gs-funnel-list-card__icon-button"
            :aria-label="option.text"
            :title="option.text"
            @click="option.callback()"
            v-tooltip="option.text"
          >
            <component :is="option.icon" />
          </button>
        </div>
        <drop-menu :menu-items="menuItems" small></drop-menu>
      </div>
    </div>
  </article>
</template>

<script>
import FunnelDraftNotice from './FunnelDraftNotice.vue';
import GiftsIcon from '@/assets/images/icons/GiftsIcon.svg';
import MegaphoneIcon from '@/assets/images/icons/MegaphoneIcon.svg';
import ToolsIcon from '@/assets/images/icons/ToolsIcon.svg';
import TrophyIcon from '@/assets/images/icons/TrophyIcon.svg';
import HandshakeIcon from '@/assets/images/icons/HandshakeIcon.svg';
import DocumentIcon from '@/assets/images/icons/DocumentIcon.svg';

export default {
  name: 'FunnelListAsset',
  components: {
    GiftsIcon,
    FunnelDraftNotice,
  },
  props: {
    funnel: {},
  },
  computed: {
    funnelImage() {
      let funnelImage = false;

      if (
        this.funnel.main_product &&
        this.funnel.main_product.checkout_page_options &&
        this.funnel.main_product.checkout_page_options.product_image &&
        this.funnel.main_product.checkout_page_options.product_image != ''
      )
        funnelImage =
          this.funnel.main_product.checkout_page_options.product_image;

      return funnelImage;
    },
    menuItemsIcons() {
      const menuItemsIcons = [];
      menuItemsIcons.push({
        icon: GiftsIcon,
        text: this.$t('frontend_funnels_manage_products'),
        callback: () => this.$emit('onManageProducts', this.funnel.id),
      });
      menuItemsIcons.push({
        icon: MegaphoneIcon,
        text: this.$t('frontend_funnels_affiliate_signup_promo_tools'),
        callback: () => this.$emit('onManagePromotools', this.funnel.id),
      });
      if (this.funnel.main_product_id) {
        menuItemsIcons.push({
          icon: ToolsIcon,
          text: this.$t('forntend_checkout_links'),
          callback: () => this.$router.push({ name: 'productsCheckoutLinks', params: { id: this.funnel.id, product_id: this.funnel.main_product_id } }),
        });
      }
      menuItemsIcons.push({
        icon: TrophyIcon,
        text: this.$t('frontend_leaderboards'),
        callback: () => this.$router.push({ name: 'leader_boards' }),
      });
      menuItemsIcons.push({
        icon: HandshakeIcon,
        text: this.$t('frontend_gduikit_sidebar_manage_affiliates'),
        callback: () => this.$router.push({ name: 'affiliates', query: { funnel_id: this.funnel.id} }),
      });
      menuItemsIcons.push({
        icon: DocumentIcon,
        text: this.$t('frontend_gduikit_sidebar_reports'),
        callback: () => this.$router.push({ name: 'vendor_report', query: { funnel_id: this.funnel.id} }),
      });
      return menuItemsIcons;
    },
    menuItems() {
      const menuItems = [];
      menuItems.push({
        text: this.$t('frontend_funnels_settings'),
        callback: () => this.$emit('onEditFunnel', this.funnel.id),
      });

  
      menuItems.push({
        text: this.$t('frontend_funnels_clone'),
        callback: () => this.$emit('onCloneFunnels', this.funnel.id),
      });
      menuItems.push({
        text: this.$t('frontend_funnels_delete'),
        callback: () => this.$emit('onDeleteFunnels', this.funnel.id),
      });

      return menuItems;
    },
  },
  methods: {
    backgroundImageUrl(url) {
      if (url) {
        return `url("${url}")`;
      }

      return '';
    },
    sendToManageProducts() {
      this.$emit('onManageProducts', this.funnel.id);
    },
    sendToDashboard() {
      this.$router.push({ name: 'funnelDashboard', params: { id: this.funnel.id } });
    },
  },
};
</script>

<style lang="scss">
.gs-funnel-list-card {
  display: grid;
  grid-template-columns: 160px minmax(0, 1fr);
  gap: 0;
  margin: 10px 0;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e4e8f1;
  border-radius: 8px;
  box-shadow: 0 14px 32px rgba(31, 37, 72, .06);
}

.gs-funnel-list-card__media {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 126px;
  padding: 18px;
  color: #ff5b7f;
  background: #fbfcff;
  border: 0;
  border-right: 1px solid #edf0f6;
  cursor: pointer;
}

.gs-funnel-list-card__image,
.gs-funnel-list-card__placeholder {
  width: 100%;
  height: 88px;
  object-fit: contain;
}

.gs-funnel-list-card__placeholder {
  fill: currentColor;
}

.gs-funnel-list-card__content {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  padding: 18px 20px;
}

.gs-funnel-list-card__main {
  min-width: 0;
}

.gs-funnel-list-card__title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.gs-funnel-list-card__title-row h3 {
  margin: 0;
  color: #171b3f;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 1.28 !important;
}

.gs-funnel-list-card__status {
  padding: 5px 8px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  border-radius: 6px;
}

.gs-funnel-list-card__status.is-live {
  color: #28a866;
  background: #dff7ea;
}

.gs-funnel-list-card__status.is-draft {
  color: #b77a00;
  background: #fff0c9;
}

.gs-funnel-list-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  margin: 0 0 8px;
  color: #7c849c;
  font-size: 12px;
}

.gs-funnel-list-card__description {
  max-width: 720px;
  margin: 0;
  color: #4f5875;
  font-size: 13px;
  line-height: 1.45;
}

.gs-funnel-list-card__actions,
.gs-funnel-list-card__icons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.gs-funnel-list-card__actions {
  flex-shrink: 0;
}

.gs-funnel-list-card__icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  color: #5f6884;
  background: #f7f8fc;
  border: 1px solid #e4e8f1;
  border-radius: 6px;
}

.gs-funnel-list-card__icon-button:hover {
  color: #ff5b7f;
  background: #fff5f7;
  border-color: #ffc4d1;
}

.gs-funnel-list-card__media:focus-visible,
.gs-funnel-list-card__icon-button:focus-visible {
  outline: 3px solid rgba(255, 91, 127, .3);
  outline-offset: -3px;
}

.gs-funnel-list-card__icon-button svg {
  width: 18px;
  height: 18px;
  fill: currentColor;
}

@media (max-width: 800px) {
  .gs-funnel-list-card {
    grid-template-columns: 1fr;
  }

  .gs-funnel-list-card__media {
    border-right: 0;
    border-bottom: 1px solid #edf0f6;
  }

  .gs-funnel-list-card__content {
    flex-direction: column;
  }
}
.gs-funnel-list-card.is-unpublished { background:#FBF4E8; border-color:#DDC7A8; }
.gs-funnel-list-card.is-unpublished .gs-funnel-list-card__media { background:linear-gradient(180deg,#F9EDDA,#FBF4E8); }
.gs-funnel-list-card__status.is-draft { color:#A92E28; background:#FFE0D7; border:1px solid #ECA99A; font-size:12px; font-weight:800; padding:5px 9px; }
</style>
